import customEvent from './customEvent.js';

export default class {
    //画像の遅延読み込み
    constructor() {
        this.items = document.querySelectorAll('[data-lazysrc]');
    }

    start() {
        [].forEach.call(this.items, (v,i) => {
            const src = v.getAttribute("data-lazysrc");
            v.setAttribute("src", src);
        });
    }
}
